import { getOptimizedImageUrl, ImageFormat, ImageSize } from '@/ui/utils/getOptimizedImageUrl';
import { ImageFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';

// Pre-bake a fixed Crystallize variant URL and drop `variants` so OptimizedImage serves that exact
// size instead of picking the largest. Used where a small, fixed size is wanted (e.g. gallery
// thumbnails, non-active slides) rather than the full-resolution original.
export const resizedImage = (
  image: ImageFragment | null | undefined,
  size: ImageSize,
): ImageFragment | undefined => {
  if (!image?.url) {
    return undefined;
  }

  return {
    ...image,
    url: getOptimizedImageUrl(image.url, size, ImageFormat.WEBP),
    variants: [],
  };
};
